/* global $ */

const $enrollSignup = $('.js-enroll-signup');
const $enrollSignupType = $('.js-enroll-signup-type');
const $enrollSignupForm = $('.js-enroll-signup-form');
const $companyFields = $('.js-company');
const $enrollSoobSubsidie = $('.js-enroll-soobsubsidie');
const $enrollEmployeeNumber = $('.js-enroll-employee-number');
const $enrollAdrType = $('.js-enroll-adr-type');
const $adrCourseDateWarning = $('.js-adr-course-date-warning');
const $enrollNoNewStudent = $('.js-no-new-student');
const $enrollContactPerson = $('.js-enroll-contact-person');
const $enrollContactPhoneNumber = $('.js-enroll-contact-phone-number');
const $enrollContactEmail = $('.js-enroll-contact-email');
const $addressFields = $('.js-address');
const $addressFieldsInput = $('.js-address :input');
const $enrollJobtransClient = $('.js-enroll-jobtrans-client');
const $jobtransClient = $('.js-jobtrans-client');
const $jobtransNonClient = $('.js-jobtrans-non-client');

const enrollSignupType = {
  initialize() {
    if ($enrollSignup.length) {
      this.createListeners();

      if ($enrollSignupType.val()) {
        this.select();
      }
    }
  },

  createListeners() {
    $enrollSignupType.on('change', () => {
      this.select();
      this.toggleContactPersonFields();
    });

    $enrollSoobSubsidie.on('change', () => {
      this.employeeNumber();
    });

    $enrollAdrType.on('change', () => {
      this.checkAdrType();
    });

    $enrollNoNewStudent.on('change', () => {
      this.toggleContactPersonFields();
    });

    $enrollJobtransClient.on('change', () => {
      this.toggleCompanyFields();
    });
  },

  select() {
    if ($enrollSignupType.val() === 'private') {
      $companyFields.hide();
    } else if ($enrollSignupType.val() === 'company') {
      $companyFields.show();
    }

    $addressFields.hide();
    $addressFieldsInput.prop('required', false);

    $enrollSignupForm.show();
  },

  employeeNumber() {
    if ($enrollSoobSubsidie.val() === '1') {
      $enrollEmployeeNumber.find('input').prop('required', true);
      $enrollEmployeeNumber.show();
    } else if ($enrollSoobSubsidie.val() === '0') {
      $enrollEmployeeNumber.hide();
      $enrollEmployeeNumber.find('input').prop('required', false);
    }
  },

  toggleCompanyFields() {
    if ($enrollJobtransClient.val() === '1') {
      $jobtransClient.hide();
      $jobtransNonClient.show();
    } else {
      $jobtransClient.show();
      $jobtransNonClient.hide();
    }
  },

  checkAdrType() {
    if ($enrollAdrType.val() !== 'ADR basis nieuw') {
      $adrCourseDateWarning.show();
    } else {
      $adrCourseDateWarning.hide();
    }
  },

  toggleContactPersonFields() {
    let toggle = false;

    if ($enrollSignupType.val() === 'company' && $enrollNoNewStudent.val() === '0') {
      toggle = true;
    }

    if ($enrollSignupType.val() === 'private' && $enrollNoNewStudent.val() === '0') {
      $addressFields.show();
      $addressFieldsInput.prop('required', true);
    } else {
      $addressFields.hide();
      $addressFieldsInput.prop('required', false);
    }

    $enrollContactPerson.toggle(toggle);
    $enrollContactPhoneNumber.toggle(toggle);
    $enrollContactEmail.toggle(toggle);
    $enrollContactPerson.find('input').prop('required', toggle);
    $enrollContactPhoneNumber.find('input').prop('required', toggle);
    $enrollContactEmail.find('input').prop('required', toggle);
  },
};

export default enrollSignupType;
